


























































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import CommandList from '@/models/status/commandlist';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import * as def from '@/common/definitions';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';

@Component({
  components: {
    KmyLogTagText,
    KmyChatTagText,
  },
})
export default class CommandListView extends Vue {
  @Prop() private list!: CommandList;
  @Prop() private characterDeleteTurn!: number;
  @Prop() private canSafeOut!: boolean;
  @Prop() private canSecretary!: boolean;
  @Prop() private canCommandComment!: boolean;
  @Prop() private canSubBuilding!: boolean;
  @Prop() private canBuyTown!: boolean;
  @Prop() private gameDate!: api.GameDateTime;
  private selectedCommandCategory: number = 0;
  private isMultiCommandsSelection: boolean = false;
  private isOpenAxb: boolean = false;
  private isRanged: boolean = false;
  private isOpenSafePopup: boolean = false;
  private isOpenScouterPopup: boolean = false;
  private isOpenSecretaryPopup: boolean = false;
  private isOpenFormationPopup: boolean = false;
  private isOpenItemPopup: boolean = false;
  private isOpenTrainingPopup: boolean = false;
  private isOpenSubBuildingPopup: boolean = false;
  private isOpenMonthPopup: boolean = false;
  private isOpenAiCharacterPopup: boolean = false;
  private isOpenMovePopup: boolean = false;
  private isOpenMoveInput: boolean = false;
  private moveToNumber: number = 1;
  private isUpdatingCountrySettings: boolean = false;

  private axbA: number = 3;
  private axbB: number = 0;

  private get deleteTurn(): number {
    return def.CHARACTER_DELETE_TURN - this.characterDeleteTurn;
  }

  public get isShowDeleteTurn(): boolean {
    let isShow = this.characterDeleteTurn > 0;
    if (isShow && this.gameDate.year < def.UPDATE_START_YEAR) {
      isShow = this.list.isFewRemaining;
    }
    return isShow;
  }

  private updateCountryCommanderMessageRead(id: number) {
    this.isUpdatingCountrySettings = true;
    api.Api.setCountryCommanderRead(id)
      .catch(() => {
        NotificationService.countryCommandersMessageReadFailed.notify();
      })
      .finally(() => {
        this.isUpdatingCountrySettings = false;
      });
  }

  @Watch('axbA')
  @Watch('axbB')
  @Watch('isOpenAxb')
  private updatePreview() {
    if (this.isOpenAxb) {
      this.list.inputer.previewAxbCommands(this.axbA, this.axbB);
    } else {
      this.list.inputer.removePreviews();
    }
  }

  private onCommandSelected(command: api.CharacterCommand, event?: MouseEvent) {
    if (this.isMultiCommandsSelection) {
      this.list.inputer.selectMultipleCommand(command);
    } else {
      if (event && event.shiftKey) {
        this.list.inputer.selectMultipleCommand(command);
      } else {
        this.list.inputer.selectSingleCommand(command);
      }
    }
  }

  private onResignCommand() {
    this.$emit('yesno', {
      message: '下野すると数日間他国に仕官できなくなります。本当に下野しますか？',
      onYes: () => this.list.inputer.inputCommand(69),
    });
  }

  private scrollToNumber(num: number) {
    (this.$refs.list as Element).scrollTo(0, (num - 1) * 45);
  }
}
